/* Cart drawer extras: "Make it a pair" nudge (one hat in the bag) + gift note saved to the order */
(function () {
  var cfg = {}; try { cfg = JSON.parse(document.getElementById('cart-extras-config').textContent); } catch (e) {}
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  var recCache = {};
  function recs(productId) {
    if (recCache[productId]) return Promise.resolve(recCache[productId]);
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { recCache[productId] = (d.products || []).filter(function (p) { return p.available; }); return recCache[productId]; })
      .catch(function () { return []; });
  }
  var noteTimer;
  function saveNote(note) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note }) }).catch(function () {});
    }, 500);
  }
  window.HatsyCartExtras = function (cart, footer) {
    /* "Make it a pair" lives in the scrolling part of the bag, so the checkout button always stays on screen */
    var slot = document.getElementById('cart-pair-slot'), drawer = document.getElementById('cart-drawer');
    if (slot) slot.innerHTML = '';
    var gs = document.getElementById('cart-gift-slot'); if (gs) gs.innerHTML = '';
    if (drawer) drawer.classList.remove('has-pair');
    if (!footer || !cart || !cart.items || !cart.items.length) return;
    var wrap = document.createElement('div'); wrap.className = 'cx';
    /* gift note */
    if (cfg.gift) {
      var has = !!(cart.note && cart.note.trim());
      wrap.insertAdjacentHTML('beforeend', '<div class="cx-gift' + (has ? ' is-open' : '') + '"><button type="button" class="cx-gift__toggle" aria-expanded="' + has + '">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11" rx="1.5"/><path d="M2.5 9h19M12 9v11M12 9c-1.5-3.5-6-4-6-1.5S10 9 12 9zm0 0c1.5-3.5 6-4 6-1.5S14 9 12 9z"/></svg>' +
        '<span>' + esc(cfg.gift_label || 'Add a gift note') + '</span></button>' +
        '<textarea class="cx-gift__text" rows="3" maxlength="300" placeholder="' + esc(cfg.gift_placeholder || '') + '" aria-label="Gift note">' + esc(cart.note || '') + '</textarea></div>');
    }
    /* make it a pair: exactly one hat in the bag */
    var qty = cart.items.reduce(function (n, i) { return n + i.quantity; }, 0);
    if (cfg.nudge && qty === 1) {
      wrap.insertAdjacentHTML('afterbegin', '<div class="cx-pair" hidden><div class="cx-pair__head"><strong>' + esc(cfg.nudge_title || 'Make it a pair') + '</strong><span>' + esc(cfg.nudge_text || '') + '</span></div><div class="cx-pair__list"></div></div>');
      var item = cart.items[0];
      recs(item.product_id).then(function (list) {
        var box = slot ? slot.querySelector('.cx-pair') : wrap.querySelector('.cx-pair'); if (!box) return;
        list = list.filter(function (p) { return p.id !== item.product_id; }).slice(0, 3);
        if (!list.length) return;
        box.querySelector('.cx-pair__list').innerHTML = list.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || {};
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          return '<div class="cx-pair__item"><a href="' + esc(p.url) + '" class="cx-pair__img">' + (img ? '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="cx-pair__name">' + esc(p.title) + '<span>' + money(p.price) + '</span></div>' +
            '<button type="button" class="cx-pair__add" data-id="' + v.id + '">+ Add</button></div>';
        }).join('');
        box.hidden = false;
        if (slot && box.parentNode !== slot) { slot.innerHTML = ''; slot.appendChild(box); }
        if (drawer) drawer.classList.add('has-pair');
        box.querySelectorAll('.cx-pair__add').forEach(function (b) {
          b.addEventListener('click', function () {
            if (b.disabled || !b.dataset.id) return; b.disabled = true; b.textContent = '\u2026';
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.id, quantity: 1 }] }) })
              .then(function () { if (typeof window.refreshCart === 'function') window.refreshCart(); })
              .catch(function () { b.disabled = false; b.textContent = '+ Add'; });
          });
        });
      });
    }
    var pairBox = wrap.querySelector('.cx-pair');
    if (pairBox && slot) slot.appendChild(pairBox);   /* shown once its hats have loaded */
    if (!wrap.children.length) return;
    /* the gift note sits under the hats in the scrolling part, so the bottom bar stays small: subtotal + checkout */
    var giftSlot = document.getElementById('cart-gift-slot');
    if (giftSlot) { giftSlot.innerHTML = ''; giftSlot.appendChild(wrap); } else footer.insertBefore(wrap, footer.firstChild);
    var tg = wrap.querySelector('.cx-gift__toggle');
    if (tg) {
      var g = wrap.querySelector('.cx-gift'), ta = wrap.querySelector('.cx-gift__text');
      tg.addEventListener('click', function () { var open = !g.classList.contains('is-open'); g.classList.toggle('is-open', open); tg.setAttribute('aria-expanded', open); if (open) ta.focus(); });
      ta.addEventListener('input', function () { saveNote(ta.value); });
    }
  };
})();
